export default __webpack_public_path__ + "static/media/chip.03a4503d.png";